<template >
    <v-card hover class='listCard' outlined>
      <v-list-item two-item>
      <v-card-text class="infoTile">
        <div class='overline pb-3'>{{department}}</div>
        <h1>{{name}}</h1>
        <div class='subtitle-1 mb-3'>{{title}}</div>
        <v-icon left color='primary'>mdi-email</v-icon>
        <a v-if='email'>{{email}}</a>
      </v-card-text>
      <v-img class="employeePicture" v-if="picture" :src='picture' max-height='140' max-width='140'/>
      </v-list-item>
    </v-card>
</template>
<script>
export default{
    props:{
        department:String,
        name:String,
        title:String,
        email:String,
        picture: String
    }
}
</script>

<style lang="stylus" scoped>
.listCard .name{
    word-break: keep-all;
}
  

.listCard:hover{
outline 2px solid #00387A !important
}

.listCard{
    height: 100%;
    min-width: 410px;    
}
  
a{
text-decoration none;
}
.infoTile{
    max-width: 70%;
    min-height: 230px;
}
.employeePicture{
border-radius: 50%;
position: absolute;
top: 22%;
left: 64%;
}
</style>